module.exports = __webpack_public_path__ + "static/media/edit.f361f8b9.svg";